var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoRightMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "102px",
    height: "102px",
    viewBox: "0 0 102 102",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "247191AF-49A2-48EA-9E11-0180A09A1A68") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "36-Sixtbook_directly_to_Queston_for,m",
    transform: "translate(-799.000000, -204.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(545.000000, 124.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(255.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_check",
    transform: "translate(15.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    points: "0 0 71.2997347 0 71.2997347 78.4533985 0 78.4533985"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#191919",
    strokeWidth: 2,
    cx: 50,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#191919",
    strokeWidth: 2,
    points: "23 52.6581876 39.26 69 39.26 69 77 31"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRightMark);
export default __webpack_public_path__ + "static/media/ico_rightMark.20b93b7ef96be53289c1736dd418b78b.svg";
export { ForwardRef as ReactComponent };